module.exports = __webpack_public_path__ + "static/media/filterPurple.db16d6a3.svg";